
import React, { useContext, useState } from "react"
import LayoutContext from "gatsby-theme-photography-portfolio/src/context/LayoutContext"//"../context/LayoutContext"
import { StaticQuery, graphql } from "gatsby"
import { Wrapper, DescriptionWrapper, Title, ReadMore, Label, InfoWrapper, Holder,List, ListItem } from "./styles"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import { LeftTwoThirds, RightTwoThirds } from "../../utils/styles"
import { Link } from "gatsby"
import slugify from "slugify"
import { renderRichText } from 'gatsby-source-contentful/rich-text'

import { PiDotOutlineDuotone,PiLinkBold  } from 'react-icons/pi';
import {MdExpandMore,MdExpandLess} from 'react-icons/md';
import Accordion from "../Accordion";

//PiFilePdf
//PiLinkBold

/* import { getImage, GatsbyImage } from "gatsby-plugin-image"
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
 */

const MiniHeaderWorks = ({ title, imagePreview, description, descriptionShort, exhibitions, publications, awards }) => {
  let link = `${slugify(imagePreview.title.toLowerCase())}`;
  console.log("ECCO I DATI", title, imagePreview, description, descriptionShort, exhibitions, publications, awards);
  const [descOpen, setDescOpen] = useState(false);
  const [awardOpen, setAwardOpen] = useState(false);
  const [exibitOpen, setExibitOpen] = useState(false);
  const [pubbOpen, setPubbOpen] = useState(false);

  
  const data = ( exhibitions, publications, awards) => {
    let dataArray = [
      {
        title: 'Exhibitions',
        content: exhibitions,
        contentType:"exhibitions",
        disabled: false,
      },
      {
        title: 'Publications',
        content: publications,
        contentType:"publications",
        disabled: false,
      },
      {
        title: "Awards",
        content: awards,
        contentType:"awards",
        disabled: false,
      },
      {
        title: "Description",
        content: description,
        contentType:"description",
        disabled: false,
      },
    ];
   
    return dataArray.filter(el=>el.content!==null);
  };
  
  

  return (
    <Holder>
      <LeftTwoThirds>
        <InfoWrapper>
          <Title>{title}</Title>
          <Accordion data={
             data(exhibitions,publications,awards)
             
          }></Accordion>
          {/* <DescriptionLabel onClick={() => setDescOpen(!descOpen)} >_pubblications:</DescriptionLabel> */}
          {/* <Label onClick={() => setPubbOpen(!pubbOpen)}>
            
            <button>{pubbOpen?(<MdExpandLess/>):(<MdExpandMore/>)} </button>
            <span>Pubblications</span>
          </Label>
          <List expanded={pubbOpen} >
            {publications && publications.map((el, index) => {
              return <ListItem key={index}>
                <span className="icon"><PiDotOutlineDuotone/></span>
                {el.pdf ?(<><a target="_blank"  href={el.pdf.file.url}>
                  <span>{el.title}</span>
                </a></>)
                :
                el.url?
                <><a href={el.url}>
                  <span>{el.title}</span>
                </a></>
                :
                <div>
                  <span >{el.title}</span>
                </div>
                }
              </ListItem>
            })}

          </List>
          <Label onClick={() => setExibitOpen(!exibitOpen)}>
            
            <button>{exibitOpen?(<MdExpandLess/>):(<MdExpandMore/>)} </button>
            <span>Exhibitions</span>
          </Label>
          <List expanded={exibitOpen}>

            {exhibitions && exhibitions.map((el, index) => {

              return <ListItem key={index}>
                <span className="icon"><PiDotOutlineDuotone/></span>
                {el.urk ?(<a target="_blank"  href={el.url}>
                  <span>{el.name}</span>
                  {el.location ? (<span>{el.location}</span>) : ""}
                </a>)
                :
                <div>
                  <span >{el.name}</span>
                  {el.location ? (<span className="location">{el.location}</span>) : ""}
                </div>}
              </ListItem>
            })}

          </List>
          <Label onClick={() => setAwardOpen(!awardOpen)}>
            
            <button>{awardOpen?(<MdExpandLess/>):(<MdExpandMore/>)} </button>
            <span>Awards</span>
          </Label>
          <List expanded={awardOpen}>

            {awards && awards.map((el, index) => {

              return <ListItem key={index}>
                <span className="icon"><PiDotOutlineDuotone/></span>
                {el.url ?(<a target="_blank"  href={el.url}>
                  <span>{el.name}</span>
                </a>)
                :
                <div>
                  <span >{el.name}</span>
                </div>}
              </ListItem>
            })}

          </List>

 */}
          {/* <Label onClick={() => setDescOpen(!descOpen)}>
            <button>{descOpen?(<MdExpandLess/>):(<MdExpandMore/>)} </button>
            Notes
          </Label>
          <DescriptionWrapper expanded={descOpen}>
            {
              //renderRichText(descOpen ? description : descriptionShort)
              renderRichText(description)
            }
          </DescriptionWrapper> */}
          {/* <ReadMore onClick={() => setDescOpen(!descOpen)}> {descOpen ? "Read less" : "Read more"}</ReadMore> */}
        </InfoWrapper>

        <Link
          id={"photo-" + imagePreview.title}
          key={imagePreview.id}
          to={link}
        >
          <GatsbyImage
            image={imagePreview.gatsbyImageData}
            alt={imagePreview.title}
            objectFit="contain"
            style={{ maxHeight: "100%" }}
          />
        </Link>

      </LeftTwoThirds>
    </Holder>

  )
}

export default MiniHeaderWorks
